// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-mediumOnConfined-badge-6a539f72"};